import { useState } from 'react'

import { getAvailableOptionalAddons, getChildSaleLines, getParentSaleLinesForDisplay } from '@/components/pos/posCart'
import { PosCartPanel } from './PosCartPanel'
import { PosCatalogPicker } from './PosCatalogPicker'
import { PosCategorySidebar } from './PosCategorySidebar'
import { PosCustomerPanel } from './PosCustomerPanel'
import { PosHeader } from './PosHeader'
import { PosShortcutBar } from './PosShortcutBar'

/**
 * @param {object} props
 */
export function PosLayout({
  catalogMode,
  onCatalogModeChange,
  activeCategoryId,
  onCategoryChange,
  catalogGenderFilter,
  pricingGender,
  onGenderChange,
  categories,
  services,
  loadingCategories,
  loadingServices,
  catalogError,
  products,
  loadingProducts,
  productsError,
  onServiceSelect,
  onProductSelect,
  onQuickKeySelect,
  quickKeys,
  loadingQuickKeys,
  quickKeysError,
  sale,
  saleMeta,
  stylists,
  addonOptionsByService = {},
  saleLoading,
  saleMutating,
  saleError,
  customerError,
  holdError,
  floorQueueError = '',
  canSendToFloor = false,
  onSendToFloor,
  onHoldTicket,
  onSelectCustomer,
  onClearCustomer,
  onOpenCustomerHistory,
  onOpenPayment,
  onOperation,
  onPrintServiceSlips,
  selectedLineId,
  onSelectLine,
  shortcutNotice = '',
  packageBalanceRefreshToken = '',
  totals,
  heldTicketCount = 0,
  onLoadTicket,
  onLoadAppointment,
}) {
  const [searchQuery, setSearchQuery] = useState('')

  const catalogBanner = catalogError || productsError || quickKeysError
  const selectedLine = selectedLineId != null && sale
    ? getParentSaleLinesForDisplay(sale).find((line) => line.id == selectedLineId) ?? null
    : null
  const selectedAddonOptions = selectedLine?.service_id
    ? addonOptionsByService[selectedLine.service_id] ?? []
    : []
  const hasAddons = selectedLine && sale
    ? getChildSaleLines(sale, selectedLine.id).length > 0
      || getAvailableOptionalAddons(selectedAddonOptions, getChildSaleLines(sale, selectedLine.id)).length > 0
    : false

  return (
    <div className="pos-theme pos-shell pos-v2-shell pos-terminal mx-auto flex h-full w-full max-w-none flex-col px-1 pb-1">
      <PosHeader
        catalogGenderFilter={catalogGenderFilter}
        onGenderChange={onGenderChange}
        sale={saleMeta}
        heldTicketCount={heldTicketCount}
        onLoadTicket={onLoadTicket}
        onLoadAppointment={onLoadAppointment}
        disabled={saleMutating}
      />

      <div className="pos-v2-workspace mt-1 min-h-0 flex-1">
        <PosCategorySidebar
          catalogMode={catalogMode}
          onCatalogModeChange={onCatalogModeChange}
          activeCategoryId={activeCategoryId}
          onCategoryChange={onCategoryChange}
          categories={categories}
          loadingCategories={loadingCategories}
          retailCount={products.length}
          quickKeyCount={quickKeys.length}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />

        <div className="pos-v2-center">
          {catalogBanner ? (
            <p className="shrink-0 border-b border-red-200 bg-red-50 px-4 py-2 text-xs text-red-700">
              {catalogBanner}
            </p>
          ) : null}

          <div className="pos-v2-center-split min-h-0 flex-1">
            <PosCartPanel
              sale={sale}
              stylists={stylists}
              loading={saleLoading}
              mutating={saleMutating}
              error={saleError}
              onPrintServiceSlips={onPrintServiceSlips}
              selectedLineId={selectedLineId}
              onSelectLine={onSelectLine}
            />

            <PosCatalogPicker
              catalogMode={catalogMode}
              activeCategoryId={activeCategoryId}
              pricingGender={pricingGender}
              categories={categories}
              services={services}
              loadingServices={loadingServices}
              searchQuery={searchQuery}
              products={products}
              loadingProducts={loadingProducts}
              quickKeys={quickKeys}
              loadingQuickKeys={loadingQuickKeys}
              onServiceSelect={onServiceSelect}
              onProductSelect={onProductSelect}
              onQuickKeySelect={onQuickKeySelect}
              disabled={saleMutating}
            />
          </div>
        </div>

        <PosCustomerPanel
          sale={sale}
          totals={totals}
          selectedLine={selectedLine}
          stylists={stylists}
          disabled={saleMutating}
          hasAddons={hasAddons}
          customerError={customerError}
          holdError={holdError}
          floorQueueError={floorQueueError}
          canSendToFloor={canSendToFloor}
          onSendToFloor={onSendToFloor}
          onHoldTicket={onHoldTicket}
          onSelectCustomer={onSelectCustomer}
          onClearCustomer={onClearCustomer}
          onOpenCustomerHistory={onOpenCustomerHistory}
          onOpenPayment={onOpenPayment}
          packageBalanceRefreshToken={packageBalanceRefreshToken}
          onOperation={onOperation}
        />
      </div>

      <PosShortcutBar notice={shortcutNotice} />
    </div>
  )
}
